import { type PropType } from 'vue';

export interface ChipProps {
    color?: 'red' | 'blue' | 'grey',
    badge?: boolean,
    isId?: boolean,
}

export const chipProps = {
    color: {
        type: String as PropType<ChipProps['color']>,
        default: undefined,
        required: false,
    },
    badge: {
        type: Boolean as PropType<ChipProps['badge']>,
        default: undefined,
        required: false,
    },
    isId: {
        type: Boolean as PropType<ChipProps['isId']>,
        default: undefined,
        required: false,
    },
};

export const chipEmits = {};
